/**
 *
 * @param {number}  time time in seconds
 * @param {boolean}  twoNumberForMinutes if you want two number for minutes
 * @return {string}
 */
export function convertSecondsToTime(time: any, twoNumberForMinutes = false) {
  if (Number.isNaN(time)) return '0h00m00s';

  const minutes = Math.floor(time / 60);
  const hour = Math.floor(minutes / 60);
  const seconds = Math.floor(time % 60);

  if (hour == 0 && minutes == 0 && seconds == 0) return '0h00m00s';

  const hourString = hour ? hour + 'h' : '';
  const minutesString = (minutes % 60)
    .toString()
    .padStart(twoNumberForMinutes || hour ? 2 : 1, '0');
  const secondsString = seconds.toString().padStart(2, '0');
  return `${hourString}${minutesString}m${secondsString}s`;
}

export function getModeFromStartAndEndDate(start: number, end: number) {
  let mode = 'hour';

  let diff = end - start;

  //On va partir du principe qu'il ne doit pas y avoir plus de 163 donnée par graphiques
  //Permet de voir 7 jours en mode hour
  //Permet de voir 6 mois en mode jour
  //Permet de voir 1 an en mode mois

  if (diff / 3600 <= 183) {
    return 'hour';
  } else if (diff / (3600 * 24) <= 183) {
    return 'day';
  } else {
    return 'month';
  }
}

/**
 *
 * @param {number}  time time in seconds
 * @param {boolean}  twoNumberForMinutes if you want two number for minutes
 * @return {string}
 */
export function convertSecondsToHM(time: any, twoNumberForMinutes = false) {
  if (Number.isNaN(time)) return '0m';

  const minutes = Math.floor(time / 60);
  const hour = Math.floor(minutes / 60);

  if (hour == 0 && minutes == 0) return '0m';

  const hourString = hour ? hour + 'h' : '';
  const minutesString = (minutes % 60)
    .toString()
    .padStart(twoNumberForMinutes || hour ? 2 : 1, '0');
  return `${hourString}${minutesString}m`;
}

/**
 *
 * @param {number}  time time in seconds
 * @param {boolean}  twoNumberForMinutes if you want two number for minutes
 * @return {string}
 */
export function convertMinutesToTime(
  time: any,
  seconde = false,
  twoNumberForMinutes = true,
  afficheSeconde = false,
) {
  if (Number.isNaN(time)) {
    if (seconde) return '0h00m00s';
    else return '0h00m';
  }

  const hour = Math.floor(time / 60);
  const minutes = Math.floor(time % 60);

  if (hour == 0 && minutes == 0) {
    if (seconde) return '0h00m00s';
    else return '0h00m';
  }

  const hourString = hour ? hour + 'h' : '0h';
  let minutesString = (minutes % 60).toString();

  if (twoNumberForMinutes) {
    minutesString = minutesString.padStart(2, '0');
  }

  const secondesString = afficheSeconde ? '00s' : '';
  return `${hourString}${minutesString}m${secondesString}`;
}

// remove for unit test
export default convertSecondsToTime;

/////////////////
//  Unit Test  //
/////////////////
//
//  1. remove export (l.21)
//  2. run : "node convertSecondsToTime.js"
//

// const testing = (a, b) => {
//   const r = a === b;
//   console.log(a, b, r);
//   return r;
// };

// testing(convertSecondsToTime(0), '0:00');
// testing(convertSecondsToTime(9), '0:09');
// testing(convertSecondsToTime(10), '0:10');
// testing(convertSecondsToTime(60), '1:00');
// testing(convertSecondsToTime(70), '1:10');
// testing(convertSecondsToTime(70, true), '01:10');
// testing(convertSecondsToTime(205), '3:25');
// testing(convertSecondsToTime(205, true), '03:25');
// testing(convertSecondsToTime(555), '9:15');
// testing(convertSecondsToTime(555, true), '09:15');
// testing(convertSecondsToTime(1358), '22:38');
// testing(convertSecondsToTime(1358, true), '22:38');
// testing(convertSecondsToTime(3867), '1:04:27');
